<div
  [ngClass]="[
    'p-flight-detail01__item p-flight-detail01__item--2col p-flight-detail01__item--departure',
    tripSummarySvc.isOtherClass(flight.operatingAirlineCode),
    tripSummarySvc.isChangeClass(departure.estimatedDateTime)
  ]"
>
  <!-- (1.1.16) セグメント情報 (2.1 & 2.3)-->
  <div class="p-flight-detail01__time">
    <!-- (1.1.21) 出発時刻 - 1) 当該セグメント情報.isOpenSegment = true (OPEN便)の場合、未定の旨を表示する。 -->
    <div class="p-flight-detail01__time-item" *ngIf="flight.isOpenSegment; else dateTime">
      <span
        class="p-flight-detail01__time-stamp"
        [attr.aria-label]="'reader.DepartureChangeBeforeTime' | staticMsg"
        [innerHTML]="'label.hyphen' | staticMsg"
      ></span>
    </div>
    <!-- (1.1.21) 出発時刻 - 2) 上記以外の場合、当該セグメント情報.departure.dateTimeを表示する。-->
    <ng-template #dateTime>
      <!-- (1.1.21) 出発時刻 - ※当該セグメント情報.departure.estimatedDateTimeが存在する場合、取り消し線で当項目を表示する。-->
      <div class="p-flight-detail01__time-item" *ngIf="!departure.estimatedDateTime; else estimatedDatetimeBlock">
        <span
          class="p-flight-detail01__time-stamp"
          [innerHTML]="departure.dateTime || '' | dateFormat : 'default_departuredate.time'"
        ></span>
      </div>
      <ng-template #estimatedDatetimeBlock>
        <!-- (1.1.22) 最新出発日時 - 1) 当該セグメント.departure.estimatedDateTimeが存在する場合のみ表示する旨 -->
        <asw-estimate-datetime
          [newDateTime]="departure.estimatedDateTime ?? ''"
          [oldDateTime]="departure.dateTime ?? ''"
        ></asw-estimate-datetime>
      </ng-template>
    </ng-template>
    <!-- (1.1.20) 出発日(セグメント) || (1.1.23) 深夜出発日時 -->
    <div
      *ngIf="getDepartureDateTime() || getLateNightFlightDateTime(); let datetime"
      class="p-flight-detail01__time-item"
      [innerHTML]="datetime"
    ></div>
  </div>
  <div class="p-flight-detail01__detail">
    <div class="p-flight-detail01__detail-item">
      <!-- (1.1.24) 出発地 & (1.1.16) セグメント情報 (2.2) -->
      <p
        class="p-flight-detail01__detail-airport"
        [innerHTML]="getDepartureLocationName(departure.locationCode, departure.locationName)"
      ></p>
      <!-- (1.1.25) 出発ターミナル & (1.1.26) 出発搭乗口 -->
      <p *ngIf="!flight.isOpenSegment" class="p-flight-detail01__detail-terminal">
        {{
          tripSummarySvc.getTerminalAndGate(
            flight.isNhGroupOperated,
            departure.locationCode,
            departure.terminal,
            departure.gate
          )
        }}
        <!-- (1.1.26) 出発搭乗口 - ※以下のいずれかに合致する場合、ヘルプアイコン(ツールチップ有り＋リンク有り)を表示する。 -->
        <asw-tooltip
          *ngIf="tooltipDisplayTerminal; let tooltip"
          [iconImage]="tripSummarySvc.buildTooltipIcon('icon_help_primary_20.svg', 'alt.helpIcon2' | staticMsg, '20')"
          [tooltipContent]="tooltip | staticMsg"
        ></asw-tooltip>
      </p>
    </div>
  </div>
</div>
